import { ObjectSchema, array, object, string } from "yup";

import { SubscriptionDetailsFormValues } from "@/pages/backoffice/backOfficeSubscriptionPage/SubscriptionDetails";

export const createSubscriptionRequestSchema: ObjectSchema<SubscriptionDetailsFormValues> = object().shape({
  name: string().nullable().required("REQUIRED_FIELD"),
  description: string().nullable().optional(),
  permissions: array().of(string().required()).nullable().optional(),
});
